import {
    MARKETING_LIST,
    MARKETING_LIST_LOADING,
    MARKETING_LIST_LOADING_DONE,
} from '../../actions';

const INITIAL_STATE = {
    content: [],
    totalElements: 0,
    totalPages: 0,
    size: 20,
    number: 0,
    loading: false,
};

const marketing = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case MARKETING_LIST_LOADING:
            return { ...state, loading: true };
        case MARKETING_LIST:
            return {
                ...state,
                ...action.list,
            };
        case MARKETING_LIST_LOADING_DONE:
            return { ...state, loading: false };
        default:
            return state;
    }
};
export default marketing;
